export default function MobileSectionButtons({ sections, onSectionClick }) {
    return (
        <div className="mobile-section-buttons">
            { sections.map((section, index) => {
                return <div className="mobile-section-buttons__button" key={index} onClick={() => onSectionClick(index)}>{ section.name }</div>
            })}
        </div>
    )
}